// Lightweight Google Analytics 4 helper.
// gtag is loaded via /public/index.html. This module just safely wraps it
// for SPA route tracking and named conversion events.

export const track = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", eventName, params);
  } catch {
    /* swallow — never break UX for analytics */
  }
};

export const trackPageView = (path) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  } catch {
    /* ignore */
  }
};

/**
 * Read the GA4 client_id from the _ga cookie.
 * Cookie format: GA1.<domain depth>.<client_id_part1>.<client_id_part2>
 * The actual GA client_id is "<client_id_part1>.<client_id_part2>" (e.g. "1234567890.1700000000")
 */
export const getGaClientId = () => {
  if (typeof document === "undefined") return null;
  try {
    const m = document.cookie.match(/(?:^|;)\s*_ga=([^;]+)/);
    if (!m) return null;
    const parts = decodeURIComponent(m[1]).split(".");
    if (parts.length >= 4) return `${parts[2]}.${parts[3]}`;
    return null;
  } catch {
    return null;
  }
};

/**
 * Fire a Google Ads conversion. Once Wingman creates a Conversion Action in
 * the Google Ads UI he'll get a "conversion label" like "AbC-DefG_HIJ1234567".
 * The full send_to value is "AW-18151154728/<label>".
 *
 *   trackAdsConversion("AbC-DefG_HIJ1234567")             // signup, contact form
 *   trackAdsConversion("xyzLabel", { value: 499, currency: "ZAR", transaction_id: "sub_123" })  // purchase
 */
export const trackAdsConversion = (label, { value, currency = "ZAR", transaction_id } = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  if (!label) return;
  const params = { send_to: `AW-18151154728/${label}` };
  if (typeof value === "number") params.value = value;
  if (currency) params.currency = currency;
  if (transaction_id) params.transaction_id = transaction_id;
  try {
    window.gtag("event", "conversion", params);
  } catch {
    /* ignore */
  }
};
